import { Component } from '@angular/core';

@Component({
  selector: 'app-lock-icon-svg',
  templateUrl: './lock-icon-svg.component.html',
  styleUrl: './lock-icon-svg.component.scss'
})
export class LockIconSvgComponent {

}
